__turbopack_context__.v({
  "card-footer": "LinkCard-module-scss-module__ioTb-W__card-footer",
  "card-layout": "LinkCard-module-scss-module__ioTb-W__card-layout",
  "card-link": "LinkCard-module-scss-module__ioTb-W__card-link",
  "card-title": "LinkCard-module-scss-module__ioTb-W__card-title",
  "ellipsis": "LinkCard-module-scss-module__ioTb-W__ellipsis",
  "footer-link": "LinkCard-module-scss-module__ioTb-W__footer-link",
  "link-card": "LinkCard-module-scss-module__ioTb-W__link-card",
  "no-title-underline": "LinkCard-module-scss-module__ioTb-W__no-title-underline",
});
